export const CATEGORY_MAP = {
  CASES: 1,
  EVIDENCE: 2,
  STORAGE: 3,
  QA_ENTRIES: 4,
  ACQUISITIONS: 5,
  FPR: 6,
  TIME_ENTRIES: 7,
};
